jQuery(function($) {
    
    const is_mobile = window.innerWidth < 768;

    // Gestionar la apertura del select con animación
    $('.select2').on('select2:open', function () {

        if (!is_mobile) return;

        const $dropdown = $('.select2-dropdown');

        // Limpia posibles clases previas
        $dropdown.removeClass('closing-to-bottom');

        // Forzar reflow para que la clase de entrada se anime correctamente
        void $dropdown[0].offsetWidth;

        // Añade clase de entrada
        $dropdown.addClass('open-from-bottom');
    });

    // Gestionar el cierre del select con animación
    let isClosingManually = false;

    $('.select2').on('select2:closing', function (e) {

        if (!is_mobile) return;

        // Cuando lo cerramos manualmente, no gestionamos el evento
        //  y dejamos que se cierre nativamente
        if (isClosingManually) {
            isClosingManually = false;
            return;
        }

        const $select = $(this);
        const $dropdown = $('.select2-dropdown');

        e.preventDefault();

        $dropdown
            .removeClass('open-from-bottom')
            .addClass('closing-to-bottom');

        setTimeout(function () {
            isClosingManually = true;
            $select.select2('close');
        }, 300);
    });

    // Añade el indicador (punto negro) en la opción seleccionada
    function addSelect2Indicator(state) {
        
        // Si no tiene id, es un label
        if (!state.id) {
            return state.text;
        }

        const opacity = $(state.element).is(":selected") ? 'opacity-100' : 'opacity-0';

        let indicator = `<i data-lucide="dot" class="select2-indicator stroke-4 ${opacity}"></i>`;
        let $state = $(`<span class="flex items-center">${indicator} ${state.text}</span>`);

        return $state;
    }

    // Renderizar icono del indicador solo si el select lo tiene como opción
    $('.select2').on('select2:open', function () {
        if ($(this).data('indicator')) {
            // Timeout necesario para que funcione
            setTimeout(function() {
                lucide.createIcons();
            }, 0)
        }
    });

    // Añadir label
    $('.select2').on('select2:open', function () {

        const label = $(this).data('label');

        if (!label) {
            return;
        }

        const $dropdown = $('.select2-dropdown');

        // Evitar duplicados
        if ($dropdown.find('.select2-header-label').length === 0) {
            const $label = $(`<div class="select2-header-label">${label}</div>`);
            $dropdown.prepend($label);
        }
    });

    // Añadir placeholder al buscador
    $('.select2').on('select2:open', function () {
        const $select = $(this);
        const placeholder = $select.data('search-placeholder');

        const $searchInput = $('.select2-dropdown .select2-search__field');

        if (placeholder) {
            $searchInput.attr('placeholder', placeholder);
        }
    });

    // Añadir icono en el buscador
    $('.select2').on('select2:open', function () {
        const $dropdown = $('.select2-dropdown');

        // Asegúrate de no duplicarlo en cada apertura
        if ($dropdown.find('.lucide-search').length === 0) {
            const $container = $dropdown.find('.select2-search--dropdown');
            const $input = $container.find('input');

            // Añadir wrapper relativo si no existe
            if (!$container.hasClass('relative')) {
            $container.addClass('relative');
            }

            // Aplicar padding al input para dejar espacio al icono
            $input.addClass('!ps-8');

            // Insertar el icono
            const $icon = $(`
            <i data-lucide="search"
                class="lucide w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            </i>
            `);

            $container.append($icon);
            lucide.createIcons(); // Renderizar icono
        }
    });

    // Recolocar horizontalmente el dropdown si se sale del viewport
    $('.select2').on('select2:open', function (e) {
        let $dropdown = $('.select2-dropdown');
        let $trigger = $(this).next('.select2-container');

        let triggerOffset = $trigger.offset();
        let triggerWidth = $trigger.outerWidth();
        let dropdownWidth = $dropdown.outerWidth();
        let viewportWidth = $(window).width();

        // ¿El dropdown se saldría del viewport por la derecha?
        if ((triggerOffset.left + dropdownWidth) > viewportWidth) {
            // Alinear a la derecha del trigger
            $dropdown.css({
                left: 'auto',
                right: 0 - triggerWidth,
            });
        } else {
            // Alinear por defecto
            $dropdown.css({
                left: 0,
                right: 'auto',
            });
        }
    });

    // Inicialización de los selects
    $('.select2').each(function () {
        let $select = $(this);
        let options = {};

        // Leer configuración desde data-options
        if ($select.data('options')) {
            try {
                options = JSON.parse($select.attr('data-options'));
            } catch (e) {
                console.warn('Error parsing data-options:', e);
            }
        }

        let indicator = $select.data('indicator');

        if (indicator) {
            options.templateResult = addSelect2Indicator;
        }
        
        // Inicializar Select2
        $select.select2(options);
            
        let select2Container = $select.next('.select2-container');

        let $icon = $('<i data-lucide="chevron-down" class="lucide w-4 h-4 absolute right-0 top-[45%] -translate-y-1/2 pointer-events-none text-gray-500"></i>');

        // Añadir el icono dentro del select2
        select2Container.find('.select2-selection').css('position', 'relative').append($icon);

        // Renderizar el icono (Lucide requiere esto si usas data-lucide)
        lucide.createIcons();
    });

});